import { Loader2 } from "lucide-react";

interface LoadingOverlayProps {
  isVisible: boolean;
  message?: string;
  subMessage?: string;
}

export function LoadingOverlay({
  isVisible,
  message = "Processing...",
  subMessage,
}: LoadingOverlayProps) {
  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="bg-white rounded-lg p-8 shadow-xl max-w-sm w-full mx-4">
        <div className="flex flex-col items-center space-y-4">
          <Loader2 className="h-8 w-8 animate-spin text-purple-600" />
          <div className="text-center">
            <h3 className="text-lg font-semibold text-gray-900">{message}</h3>
            {subMessage && (
              <p className="text-sm text-gray-500 mt-1">{subMessage}</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
